var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBloodDonation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0049 5.53238C9.42988 3.60113 8.73363 1.95863 8.33488 0.978633C8.20863 0.669883 7.78988 0.669883 7.66488 0.978633C7.26613 1.95863 6.56988 3.60113 4.99488 5.53238C4.00863 6.74238 3.03613 8.51363 3.03613 10.2586C3.03613 13.2361 5.18488 15.2524 7.99988 15.2524C10.8149 15.2524 12.9636 13.2349 12.9636 10.2586C12.9636 8.44488 11.9911 6.74238 11.0049 5.53238Z",
    fill: "#E5322E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37239 9.97984C10.1661 8.46984 10.0536 6.99234 10.6811 7.25859C11.5336 7.62234 12.4774 9.49109 12.1236 11.1848C11.8711 12.3923 11.0561 13.1236 10.0174 12.7748C9.17863 12.4936 8.65739 11.3398 9.37239 9.97984Z",
    fill: "#FF6050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloodDonation);
export default __webpack_public_path__ + "static/media/blood-donation.2850c0d6ce10f2875fe1d2e671e1a6ce.svg";
export { ForwardRef as ReactComponent };